export const isSpaceKey = (event: KeyboardEvent | React.KeyboardEvent): boolean => {
	return event.key === ' ' || event.code === 'Space' || event.keyCode === 32;
};
